import {
  useMutation,
  type UseMutationOptions,
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from "@tanstack/react-query";

import { ApiClient } from './api.client.js';
import {type CreateMonitor, type Monitor, type UpdateMonitor} from '../models/index.js';


export const UsersApiKeys = {
  GET_USERS: 'GET_USERS',
  GET_USER: 'GET_USER',
  CREATE_USER: 'CREATE_USER',
  UPDATE_USER: 'UPDATE_USER',
  DELETE_USER: 'DELETE_USER',
};

export class UsersApi extends ApiClient {
  public static async getUsers(): Promise<Monitor[]> {
    return this.http.get('/users').then((res) => res.data);
  }
  public static async getUser(id: string): Promise<Monitor> {
    return this.http.get(`/users/${id}`).then((res) => res.data);
  }
  public static async createUser(monitor: CreateMonitor): Promise<Monitor> {
    return this.http.post('/users/new', monitor).then((res) => res.data);
  }
  public static async updateUser(monitor: UpdateMonitor): Promise<Monitor> {
    return this.http.put('/users/update', monitor).then(res => res.data);
  }
  public static async deleteUser(id: string): Promise<void> {
    return this.http.delete(`/users/${id}`).then((res) => res.data);
  }
}

export function useUsers(queryOptions?: UseQueryOptions<Monitor[]>): UseQueryResult<Monitor[], unknown> {
  return useQuery<Monitor[]>([UsersApiKeys.GET_USERS], () => UsersApi.getUsers(), {...queryOptions});
}
export function useUser(id: string, queryOptions?: UseQueryOptions<Monitor>): UseQueryResult<Monitor, unknown> {
  return useQuery<Monitor>([UsersApiKeys.GET_USER, id], () => UsersApi.getUser(id), {...queryOptions});
}
export function useMutateCreateUser(mutationOptions?: UseMutationOptions<Monitor, unknown, CreateMonitor>){
  return useMutation([UsersApiKeys.CREATE_USER], (monitor: CreateMonitor) => UsersApi.createUser((monitor)), mutationOptions);
}
export function useMutateUpdateUser(mutationOptions?: UseMutationOptions<Monitor, unknown, UpdateMonitor>){
  return useMutation([UsersApiKeys.UPDATE_USER], (monitor: UpdateMonitor) => UsersApi.updateUser((monitor)), mutationOptions);
}
export function useMutateDeleteUser(mutationOptions?: UseMutationOptions<void, unknown, string>){
  return useMutation([UsersApiKeys.DELETE_USER], (id: string) => UsersApi.deleteUser((id)), mutationOptions);
}


